/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScheduleProducerCreate = {
  dayOfWeek?: ScheduleProducerCreate.dayOfWeek;
  /**
   * HH:mm format
   */
  localTime?: string;
  scheduleTypeId?: string;
  zoneId?: string;
};
export namespace ScheduleProducerCreate {
  export enum dayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
  }
}

